module.exports = __webpack_public_path__ + "static/media/lts-icon.6d62e696.png";